import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ["./nav.component.scss"],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NavComponent {
  public showTestPages = environment.showTesting;
  showAssessments: boolean = false;
  showReports: boolean = false;
  showRoster: boolean = false;
  showFiretracker: boolean = false;

  constructor(
    private readonly userService: UserService,
  ) {
    this.setUser();
  }

  setUser() {
    this.userService.getUserProfile().then((user) => {
      if (user?.baer_roles?.length > 0) {
        this.showRoster = true;
        this.showAssessments = true;
        this.showFiretracker = true;
      }
      if ((user.isROCO?.length > 0) || (user.isWOCO?.length > 0)) {
        this.showReports = true;
      }
    })
  }
}
